import {
  EditBlockColorPicker,
  EditBlockSelect,
} from '@components/EditBuildingBlocks/all';
import { itemsWithFontFamily, themePropertyMapping } from '@components/Widgets/_contentItems/all';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'ThemeEditor',
  components: {
    'edit-block-select': EditBlockSelect,
    'edit-block-color-picker': EditBlockColorPicker,
  },
  computed: {
    ...mapState('editor', ['availableFontsList']),
    ...mapGetters('campaign/widget', ['targetWidget']),
    primaryColor: {
      get() {
        // Ensure targetWidget and theme are defined before accessing
        return this.targetWidget?.theme?.button.color;
      },
      set(value) {
        this.updateThemeProperty('primaryColor', value);
      },
    },
    secondaryColor: {
      get() {
        return this.targetWidget?.theme?.button.backgroundColor;
      },
      set(value) {
        this.updateThemeProperty('secondaryColor', value);
      },
    },
    fontFamily: {
      get() {
        return this.targetWidget?.theme?.button?.fontFamily;
      },
      set(value) {
        this.updateFontFamily(value);
      },
    },
  },
  methods: {
    ...mapActions('campaign/widget', ['updateWidgetTheme']),
    updateThemeProperty(propertyKey, propertyValue) {
      const affectedItems = themePropertyMapping[propertyKey];

      Object.keys(affectedItems).forEach((contentType) => {
        const properties = affectedItems[contentType];
        properties.forEach((property) => {
          this.updateWidgetTheme({
            id: this.targetWidget.id,
            path: [contentType, property],
            value: propertyValue,
          });
        });
      });
    },
    updateFontFamily(fontFamily) {
      itemsWithFontFamily.forEach((contentType) => {
        this.updateWidgetTheme({
          id: this.targetWidget.id,
          path: [contentType, 'fontFamily'],
          value: fontFamily,
        });
      });
    },
  },
};